// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"6a16eefa","170":"83ba3357","756":"e1631f65","785":"9d5b30f8","863":"f7baed83"}[chunkId] + ".chunk.css";
};